import { useState, useEffect } from "react";
const getToday = () => {
    return new Date().toISOString().split("T")[0];
};
export const useTransactionForm = () => {

    const [form, setForm] = useState({
        scrip: "",
        date: getToday(),   // ✅ default today
        rate: "",
        quantity: "",
        transactionType: "BUY",
        amount: ""
    });

    useEffect(() => {
        const { rate, quantity, transactionType } = form;

        if (rate && quantity) {
            const baseAmount = rate * quantity;

            const charges =
                (baseAmount > 500000
                    ? baseAmount * 0.00325
                    : baseAmount > 50000
                        ? baseAmount * 0.00345
                        : baseAmount * 0.00375) + 25;

            const finalAmount =
                transactionType === "BUY"
                    ? baseAmount + charges
                    : baseAmount - charges;

            setForm(prev => ({
                ...prev,
                amount: finalAmount.toFixed(2)
            }));
        } else {
            setForm(prev => ({ ...prev, amount: "" }));
        }
    }, [form.rate, form.quantity, form.transactionType]);

    const updateField = (field, value) => {
        if (field === "scrip") {
            value = value.toUpperCase();
        }
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const resetForm = () => {
        setForm({
            scrip: "",
            date: getToday(),   // ✅ keep consistent
            rate: "",
            quantity: "",
            transactionType: "BUY",
            amount: ""
        });
    };
    return { form, updateField, resetForm };
};